export const metaActions = {
  inputChange: 'input-change',
  selectOption: 'select-option',
  deselectOption: 'deselect-option',
  removeValue: 'remove-value',
  popValue: 'pop-value',
};
